module.exports = __webpack_public_path__ + "static/img/teamHonorBg3.ac8e1b4d.png";